<template>
  <header>
    <nav class="navbar navbar-expand-lg navbar-light main-color w-100">
      <div class="col col-sm-4">
        <p class="mb-0 text-light h2" id="logo" style="cursor:default;user-select:none">
          <span class="test-header-color" v-if="app_env !== 'production'">
            【テスト環境】
          </span>
          {{config.projectName}}
        </p>
      </div>
      <div class="col col-sm-4">
        <div class="text-center">
          <span id="operation-possible" class="navbar-text text-light" v-show="isOperationPossibleShow">操作可能</span>
        </div>
      </div>
      <div id="operation-reconnect" class="ms-auto me-4">
        <a href="javascript:void(0)" :class="['text-light', 'h3', 'ms-1']" @click="meetingIdCheck()" v-if="!proInfoFlag">
          <i class="bi bi-arrow-clockwise fs-4 text-light"></i>
        </a>
      </div>
      <div class="d-none d-sm-block" style="width: 200px">
      </div>
    </nav>
    <ImageUploadModal ref="imageUploadModal" @signalingModalChangeEvent="signalingModalChangeSend" />
    <UploadImageShowModal ref="uploadImageShowModal" @signalingModalChangeEvent="signalingModalChangeSend" />
    <BookmarkModal ref="bookmarkModal" @signalingModalChangeEvent="signalingModalChangeSend" />
    <CommonModal ref="commonModalMeetingIdCheck" @confirmOk="restartMeeting" />
  </header>
</template>
<script>
import ImageUploadModal from '@/components/ImageUploadModal'
import UploadImageShowModal from '@/components/UploadImageShowModal'
import CommonModal from '@/components/CommonModal'
import BookmarkModal from '@/components/BookmarkModal'
import SignalingModel from '@/models/SignalingModel'
import CustomerEstimateDeleteModel from '@/models/CustomerEstimateDeleteModel'
import MeetingInfoGetModel from '@/models/MeetingInfoGetModel'
import MeetingStartModel from '@/models/MeetingStartModel'
import cstore from '@/store/customer-store'
import logoff from '@/mixins/logoff'
import CommonLogModel from '@/models/CommonLogModel'

export default {
  name: 'CustomerHeader',
  components: { ImageUploadModal, UploadImageShowModal, CommonModal, BookmarkModal },
  data () {
    return {
      isOperationPossibleShow: false,
      app_env: process.env.APP_ENV,
      proInfoFlag: false
    }
  },
  watch: {
    getIsOperationPossible: function (bool) {
      if (bool) {
        this.isOperationPossibleShow = true
      } else {
        this.isOperationPossibleShow = false
      }
    },
    getSignalingData (newData, oldData) {
      if (newData['event'] === 'click') {
        if (newData['id'] === 'modalSelectImage') {
          this.$refs.imageUploadModal.showModal(this.consts.attendeeType.customer, 'selectImage')
        } else if (newData['id'] === 'floristModalSelectImage') {
          this.$refs.imageUploadModal.showModal(this.consts.attendeeType.customer, 'floristSelectImage')
        } else if (newData['id'] === 'modalQrImageShow') {
          this.$refs.imageUploadModal.showModal(this.consts.attendeeType.customer, 'qrImageShow')
        } else if (newData['id'] === 'modalUploadComplateOK') {
          this.$refs.imageUploadModal.hideModal()
        } else if (newData['id'] === 'modalQrImageURL') {
          this.$refs.imageUploadModal.setQrImageUrl(newData['url'])
        } else if (newData['id'] === 'modalUploadHide') {
          this.$refs.imageUploadModal.hideModal()
        } else if (newData['id'] === 'modalUploadImageShow') {
          this.$refs.uploadImageShowModal.showModal(this.consts.attendeeType.customer)
        } else if (newData['id'] === 'modalBookmarkImageShow') {
          this.$refs.bookmarkModal.showModal(this.consts.attendeeType.customer)
        } else if (newData['id'] === 'modalShowListHide') {
          this.$refs.uploadImageShowModal.hideModal()
        } else if (newData['id'] === 'modalBookmarkListHide') {
          this.$refs.bookmarkModal.hideModal()
        } else if (newData['id'] === 'modalUploadImageReload') {
          this.$refs.uploadImageShowModal.setApiData()
        } else if (newData['id'] === 'modalBookmarkImageReload') {
          this.$refs.bookmarkModal.setApiData()
        } else if (newData['id'] === 'modalUploadImage') {
          this.$refs.imageUploadModal.customerUploadFile()
        } else if (newData['id'] === 'modalUploadImageComplete') {
          this.$refs.imageUploadModal.changeBody('uploadImageComplete')
        } else if (newData['id'] === 'deleteEstimate') {
          CustomerEstimateDeleteModel.deleteStore({'sectionL': newData['projectType']})
        }
      }
    }
  },
  computed: {
    getSignalingData () {
      return cstore.getters.signalingReceiveData
    },
    getIsOperationPossible () {
      return cstore.getters.isOperationPossible
    }
  },
  mounted () {
    this.proInfoFlag = window.location.href.includes('proInfo')
    if (this.consts.isSwitchOperationPossibleCustomerPages.includes(this.$parent.$parent.$options.name)) {
      if (cstore.getters.isOperationPossible) {
        this.isOperationPossibleShow = true
      }
    } else {
      this.isOperationPossibleShow = false
    }

    // リロード時はrouter.beforeEach()が動作しないのでbeforeunloadで最終ページを設定
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('lastRoutePath', this.$route.path)
    })
  },
  methods: {
    signalingModalChangeSend (clickName) {
      SignalingModel.sendClickEvent(clickName, this)
    },
    reconnect () {
      sessionStorage.setItem('noDisplayMessageFlag', 'true')
      // 接続OFF
      logoff.logoff_kyoutu()

      // 画面遷移
      MeetingInfoGetModel.apiSetStore(this.$refs.commonModal, () => {
        const meetingInfoStore = MeetingInfoGetModel.getStore()
        let targetPath = '/customer/meeting/agenda'
        if (meetingInfoStore) {
          let meetingurl = meetingInfoStore.meetingURL['currentURLPath']
          if (meetingurl !== '') {
            targetPath = '/customer/' + meetingurl
            if (meetingInfoStore.meetingURL['operatingPrivilege'] === '1' && sessionStorage.customerType !== this.consts.customerType.guest) {
              cstore.commit('setIsOperationPossible', true)
            } else {
              cstore.commit('setIsOperationPossible', false)
            }

            const suggestionDataStr = meetingInfoStore.meetingURL['suggestionData']
            if (suggestionDataStr) {
              const suggestionData = JSON.parse(suggestionDataStr)
              if ('suggestionType' in suggestionData) {
                localStorage.setItem('suggestionType', suggestionData['suggestionType'])
              }
            }
          }
        }
        CommonLogModel.apiSetStore(this.$refs.commonModal, {'user': 'customer', 'timestampMs': Date.now(), 'current_path': this.$route.path, 'reloadPath': targetPath}, () => {})
        this.$router.go({path: targetPath, force: true})
      })
    },
    meetingIdCheck () {
      MeetingInfoGetModel.apiSetStore(this.$refs.commonModal, () => {
        var meetingInfoStore = MeetingInfoGetModel.getStore()
        const meetingSessionInfo = JSON.parse(sessionStorage.getItem('meeting'))
        if (meetingSessionInfo['MeetingId'] !== meetingInfoStore.meetingURL['meetingId']) {
          this.$refs.commonModalMeetingIdCheck.msgBoxConfirm('間違ったミーティングルームに入室しています。正しいミーティングルームに移動しますか？')
        } else {
          this.reconnect()
        }
      })
    },
    restartMeeting: async function () {
      const meetingStartParams = {'attendeeType': this.consts.attendeeType.customer, 'customerType': sessionStorage.customerType}
      const restartResult = await MeetingStartModel.apiSetStore(this.$refs.commonModal, meetingStartParams, null, () => {
        // ミーティング参加失敗時
        alert('ミーティング情報が取得できませんでした。\nもう一度ログインしてください。')
        this.$router.push('/customer/login')
      })
      if (restartResult) {
        // ミーティング参加成功時
        sessionStorage.meeting = await JSON.stringify(restartResult.meeting)
        sessionStorage.attendee = await JSON.stringify(restartResult.attendee)
        this.reconnect()
      } else {
        this.overlayShow = false
        return false
      }
    }
  }
}
</script>

<style scoped>
.navbar {
  padding: .7rem 2rem
}
</style>
